import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/empty-img-default.svg'
import _imports_1 from '@/assets/general/link.svg'
import _imports_2 from '@/assets/general/returnLeft.svg'


const _withScopeId = n => (_pushScopeId("data-v-58c16c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "leftTabs" }
const _hoisted_4 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_5 = {
  class: "skeletonMail",
  style: {"margin":"20px 0"}
}
const _hoisted_6 = {
  key: 1,
  class: "mailList"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "name" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "empty-text" }
const _hoisted_13 = ["infinite-scroll-disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "mailContent"
}
const _hoisted_16 = { class: "historyList" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "sequence" }
const _hoisted_19 = { class: "leftUrl" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_21 = { class: "sequence" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = ["element-loading-text"]
const _hoisted_24 = {
  key: 0,
  class: "noMore"
}
const _hoisted_25 = {
  key: 2,
  class: "empty"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_27 = { class: "empty-text" }
const _hoisted_28 = {
  key: 1,
  class: "content"
}
const _hoisted_29 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_30 = {
  class: "skeletonMail",
  style: {"margin":"20px 0"}
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "name" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 2,
  class: "empty"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_36 = { class: "empty-text" }
const _hoisted_37 = ["infinite-scroll-disabled"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "returnStyle"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "historyList" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "sequence" }
const _hoisted_44 = { class: "leftUrl" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_46 = { class: "sequence" }
const _hoisted_47 = { class: "content" }
const _hoisted_48 = ["element-loading-text"]
const _hoisted_49 = {
  key: 0,
  class: "noMore"
}
const _hoisted_50 = {
  key: 3,
  class: "empty"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_52 = { class: "empty-text" }

import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getBrowser, getBookmark } from "@/api/browser/index";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { dateFormat, changeOrder } from "@/utils/format";
import { ElMessage } from "element-plus";
import { gaEvent } from "@/utils/format";
import { useRouter } from "vue-router";
import loading from "@/components/chat/loading.vue";
import { jsonData } from '@/mock/bookmarksList.js'
import { jsonDataFirefox, jsonDataGoogle, jsonDataEdge } from '@/mock/bookmarkUrl.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'bookmark',
  setup(__props) {

const store = useStore();
let router = useRouter();
const { t } = useI18n();
const deviceId = computed(() => store.state.currentDeviceInfo.id);
const deviceType = computed(() => { return store.state.deviceType })

const isVibe = computed(() => !store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);
const showRight = ref(false)
let noMoreMail = ref(false); // 是否展示没有更多数据文案

const activeBrowser = ref(0)    // 标识当前选中了哪个浏览器，用index做标识
const currentBrowser = ref('')

onMounted(async () => {
    if (!isVibe.value) {
        mailList.value = []
        noMoreMail.value = false
        await getBrowserList()
        if (mailList.value.length) {
            await getBrowserBookmark((mailList.value[0] as any).browser_name)
        } else {
            setTimeout(() => {
                rightLoading.value = false
            }, 1000)
        }
    } else {
        mailGlobalLoading.value = false
        rightLoading.value = false
        mailList.value = (jsonData.data.browser_list) as any
        currentBookmarkList.value = (jsonDataFirefox.data.bookmarks) as any
    }

    console.log('currentBookmarkList', currentBookmarkList.value);

    gaEvent("BrowserBookmarks_PV", {
        event_category: "BrowserMonitor",
        event_label: mailList.value.length > 0 ? "Data" : "NoData",
    });
})
onUnmounted(() => {
    clearInterval(closeFiveM);
})

const showUpdateTime = ref(false)
let lastUpdateTime = ref(0)

// 五分钟定时更新
let closeFiveM: any
if (!deviceType.value) {
    closeFiveM = setInterval(async () => {
        mailGlobalLoading.value = true
        rightLoading.value = true
        mailList.value = []
        currentBookmarkList.value = []
        originList.value = []
        cumulativeMailList = []
        activeBrowser.value = 0
        currentBrowser.value = ''
        await getBrowserList()
        if (mailList.value.length) {
            await getBrowserBookmark((mailList.value[0] as any).browser_name)
        } else {
            setTimeout(() => {
                rightLoading.value = false
            }, 1000)
        }

    }, 1000 * 60 * 5);
}


watch(deviceId, async () => {
    if (isVibe.value) return
    mailGlobalLoading.value = true
    rightLoading.value = true
    mailList.value = []
    currentBookmarkList.value = []
    originList.value = []
    cumulativeMailList = []
    activeBrowser.value = 0
    currentBrowser.value = ''
    await getBrowserList()
    if (mailList.value.length) {
        await getBrowserBookmark((mailList.value[0] as any).browser_name)
    } else {
        setTimeout(() => {
            rightLoading.value = false
        }, 1000)
    }
    if (!isVibe.value || !deviceType) {
        clearInterval(closeFiveM);
        if (!deviceType) setNewInterval()
    }
})

watch(isShowMore750, (newV, oldV) => {
    if (!newV) {
        showRight.value = false
    } else {
        showRight.value = true
    }
})

// 浏览器列表
const mailList = ref([]);
// 当前选中历史记录的列表
const currentBookmarkList = ref<any>([])
// 左侧骨架屏
let mailGlobalLoading = ref(true);
// 右侧loading
let rightLoading = ref(true);
// 控制页数
const currentPage = ref(1)

const getBrowserList = async () => {
    try {
        const params = {
            device_id: deviceId.value,
            target: 'bookmark',
        }
        const res = await getBrowser(params);
        console.log('resss', res);
        if (res.data.code == 200) {

            mailList.value = res.data.data.browser_list
        }

        console.log('mailList', mailList.value);
    } catch (err: any) {

    } finally {
        mailGlobalLoading.value = false;
        rightLoading.value = false
        setTimeout(() => {
            store.commit("setSyncLoading", false);
        }, 1000)
    }
}

const originList = ref([])  // 未经处理的接口数据，用来判断是否加载完所有数据的
let cumulativeMailList: any = [];

const getBrowserBookmark = async (browserName: string, currentIndex: number = 0, isFromScroll: boolean = false, isFromSync: Boolean = false) => {
    if (!isShowMore750.value) {
        showRight.value = true
    }
    if (!isFromScroll) {
        rightLoading.value = true
        currentPage.value = 1
        noMoreMail.value = false;
        activeBrowser.value = currentIndex
        currentBrowser.value = browserName
    }
    if (isVibe.value) {
        rightLoading.value = false
        console.log('browserName', browserName);
        if (browserName == 'Google Chrome') {
            currentBookmarkList.value = (jsonDataGoogle.data.bookmarks) as any
        } else if (browserName == 'Microsoft Edge') {
            currentBookmarkList.value = (jsonDataEdge.data.bookmarks) as any
        } else {
            currentBookmarkList.value = (jsonDataFirefox.data.bookmarks) as any
        }
        return
    }

    let onePageMailList = [];
    console.log(browserName, currentIndex);
    let params = {
        device_id: deviceId.value,
        browser_name: browserName,
        page: currentPage.value,
    }

    try {
        const res = await getBookmark(params)
        if (res.data.code == 200) {
            if (isFromScroll) {
                onePageMailList = res.data.data.bookmarks
                console.log('originList.value.length', originList.value.length);
                if (originList.value.length == res.data.data.total) {
                    noMoreMail.value = true;
                    return
                } else {
                    cumulativeMailList = onePageMailList
                }
                originList.value = originList.value.concat(cumulativeMailList)
                console.log('originList.value', originList.value);
                currentBookmarkList.value = originList.value
            } else {
                originList.value = res.data.data.bookmarks
                let bookmarks = res.data.data.bookmarks
                currentBookmarkList.value = bookmarks
            }

            if (!isFromSync) {
                lastUpdateTime.value = res.data.data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
            } else {
                gaEvent("BrowserBookmarks_Sync", {
                    event_category: "BrowserMonitor",
                    event_label: "Success",
                });
                if ((lastUpdateTime.value == res.data.data.update_time)) {
                    ElMessage({
                        message: t("famikeep200['Synchronization successful, no new data']"),
                        type: "success",
                    });
                } else {
                    ElMessage({
                        message: t("chat.syncSuccessed"),
                        type: "success",
                    });
                }

                lastUpdateTime.value = res.data.data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
            }

        }
    } catch (err) {
        if (isFromSync) {
            gaEvent("BrowserBookmarks_Sync", {
                event_category: "BrowserMonitor",
                event_label: "Fail",
            });
            ElMessage({
                message: t("chat.syncFailed"),
                type: "error",
            });
        }
    } finally {
        rightLoading.value = false
    }
}

const mailLoading = ref(false);
const loadMoreMailList = () => {
    if (isVibe.value) return
    console.log('chudi');
    currentPage.value = currentPage.value + 1
    mailLoading.value = true;
    setTimeout(async () => {
        await getBrowserBookmark(currentBrowser.value, currentPage.value, true);
        mailLoading.value = false;
    }, 100);
};

// 正在加载数据 或者 已经没有更多数据时 禁止滚动
const disabledMailScroll = computed(
    () => mailLoading.value || noMoreMail.value
);

// 获取日期里面的时间
const getTime = (date: Number) => {
    let time = dateFormat(date, "YYYY-MM-DD HH:mm")
    console.log('time');
    let newArr = time.split(" ")
    return newArr[1]
}

const updateInfo = async () => {
    if (isVibe.value) {
        store.commit("setSyncLoading", false);
        ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
        return
    }
    mailGlobalLoading.value = true
    rightLoading.value = true
    mailList.value = []
    currentBookmarkList.value = []
    originList.value = []
    cumulativeMailList = []
    activeBrowser.value = 0
    currentBrowser.value = ''
    await getBrowserList()
    if (mailList.value.length) {
        await getBrowserBookmark((mailList.value[0] as any).browser_name, 0, false, true)
    } else {
        setTimeout(() => {
            rightLoading.value = false
        }, 1000)
    }
    clearInterval(closeFiveM);
    setNewInterval()
}

// 设置新的定时器
const setNewInterval = () => {
    closeFiveM = setInterval(async () => {
        mailGlobalLoading.value = true
        rightLoading.value = true
        mailList.value = []
        currentBookmarkList.value = []
        originList.value = []
        cumulativeMailList = []
        activeBrowser.value = 0
        currentBrowser.value = ''
        await getBrowserList()
        if (mailList.value.length) {
            await getBrowserBookmark((mailList.value[0] as any).browser_name)
        } else {
            setTimeout(() => {
                rightLoading.value = false
            }, 1000)
        }
    }, 1000 * 60 * 5);
}

const returnLeft = () => {
    showRight.value = false
}



return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep220.Browser Bookmarks'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateInfo: updateInfo,
      showRightBox: false
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
    (isShowMore750.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(mailGlobalLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_skeleton, {
                    style: {"--el-skeleton-circle-size":"40px","width":"100%","padding-left":"10px"},
                    loading: _unref(mailGlobalLoading),
                    animated: true,
                    count: 10
                  }, {
                    template: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "circle",
                          style: {"margin-right":"12px"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"55%"}
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]))
              : (!_unref(mailGlobalLoading) && mailList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["listContent pointer", index == activeBrowser.value ? 'activeMailList' : '']),
                        key: index,
                        onClick: ($event: any) => (getBrowserBookmark(item.browser_name, index))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: item.icon_url,
                            alt: "",
                            class: "browserLogo"
                          }, null, 8, _hoisted_9),
                          _createTextVNode(" " + _toDisplayString(item.browser_name), 1)
                        ])
                      ], 10, _hoisted_7))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                  ]))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "rightTabs",
            "infinite-scroll-immediate": false,
            "infinite-scroll-disabled": disabledMailScroll.value,
            style: {"overflow":"auto"},
            "infinite-scroll-distance": "1"
          }, [
            (_unref(rightLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(loading, { class: "locationLoading" })
                ]))
              : (!_unref(rightLoading) && currentBookmarkList.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("famikeep220.Serial Number")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Url")), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBookmarkList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "body",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(index + 1), 1),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", null, _toDisplayString(item.url), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      "element-loading-text": _ctx.$t('chat.loadingText'),
                      style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                    }, null, 12, _hoisted_23), [
                      [_directive_loading, mailLoading.value]
                    ]),
                    (_unref(noMoreMail))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                  ]))
          ], 8, _hoisted_13)), [
            [_directive_infinite_scroll, loadMoreMailList]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          (!showRight.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["leftTabs", isShowMore750.value ? '' : 'mobileLefttabs'])
              }, [
                (_unref(mailGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_el_skeleton, {
                        style: {"--el-skeleton-circle-size":"40px","width":"100%","padding-left":"10px"},
                        loading: _unref(mailGlobalLoading),
                        animated: true,
                        count: 10
                      }, {
                        template: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "circle",
                              style: {"margin-right":"12px"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"55%"}
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]))
                  : (!_unref(mailGlobalLoading) && mailList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["mailList", isShowMore750.value ? '' : 'mobileLefttabs'])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["listContent pointer", index == activeBrowser.value ? 'activeMailList' : '']),
                            key: index,
                            onClick: ($event: any) => (getBrowserBookmark(item.browser_name, index))
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("img", {
                                src: item.icon_url,
                                alt: "",
                                class: "browserLogo"
                              }, null, 8, _hoisted_33),
                              _createTextVNode(" " + _toDisplayString(item.browser_name), 1)
                            ])
                          ], 10, _hoisted_31))
                        }), 128))
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                      ]))
              ], 2))
            : _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "rightTabs",
                "infinite-scroll-immediate": false,
                "infinite-scroll-disabled": disabledMailScroll.value,
                style: {"overflow":"auto"},
                "infinite-scroll-distance": "1"
              }, [
                (!isShowMore750.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "returnLeft",
                      onClick: returnLeft
                    }, _hoisted_39))
                  : _createCommentVNode("", true),
                (_unref(rightLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createVNode(loading, { class: "locationLoading" })
                    ]))
                  : (!_unref(rightLoading) && currentBookmarkList.value.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["mailContent", isShowMore750.value ? '' : 'mobileMailContent'])
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("famikeep220.Serial Number")), 1),
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("Url")), 1)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBookmarkList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "body",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_46, _toDisplayString(index + 1), 1),
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("span", null, _toDisplayString(item.url), 1)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _withDirectives(_createElementVNode("div", {
                          "element-loading-text": _ctx.$t('chat.loadingText'),
                          style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                        }, null, 12, _hoisted_48), [
                          [_directive_loading, mailLoading.value]
                        ]),
                        (_unref(noMoreMail))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                      ]))
              ], 8, _hoisted_37)), [
                [_directive_infinite_scroll, loadMoreMailList]
              ])
        ]))
  ]))
}
}

})